export const DAILY_CALENDAR = {
    DURATION: `משך`,
    START_TIME: `שעת התחלה`,
    END_TIME: `שעת סיום`,
    REMARK:`הערות`

}
